import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	border-radius: 10px;
	background: rgba(0, 0, 0, 0.2);
	overflow: hidden;
	padding: 0 10px;
`;

export const Item = styled.div`
	width: 100%;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-weight: 700;
	font-size: 22px;
	line-height: 24px;
	letter-spacing: 0.37px;
	color: #ff5d70;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ItemLast = styled.div`
	width: 100%;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-weight: 700;
	font-size: 22px;
	line-height: 24px;
	letter-spacing: 0.37px;
	color: #ff5d70;
	border-bottom: none;
`;

export const ItemLeft = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-weight: 700;
	font-size: 22px;
	line-height: 24px;
	letter-spacing: 0.37px;
	color: #ff5d70;
`;

export const Icon = styled.img`
	margin-right: 10px;
	width: ${({ width }) => width};
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 12px;
	line-height: 14px;
	text-align: right;
	letter-spacing: -0.08px;
	color: #ffffff;
`;

export const Value = styled.div`
	font-weight: 700;
	font-size: 12px;
	line-height: 14px;
	letter-spacing: -0.08px;
	color: #ffffff;
`;
